<script>
import codeTable from '@/components/table';
import edit from './codeEdit';
import topBar from './topbar';
import columnsConfig from '@/modules/config/columns';
import {mapActions, mapMutations, mapGetters} from 'vuex';
export default {
	created() {
        this.initProvince();
		this.handleGetAuthList();
		this.promiseAll();
	},
	data() {
		return {
			authOption: {
				data: [],
				pageQuery: {
					total: 0,
					pageSize: 20,
					currentPage: 1,
					pageSizeList: [20, 40, 60]
				},
				searchQuery: {
					authStatus: '',
					title: '',
					queryTimeBegin: '',
					queryTimeEnd: '',
					bidTypeId: '',
					projectTypeId: '',
                    oneTradeId: '',
                    twoTradeId: ''
				},
			},
			selectOption: {
				bidTypeId: [],
				projectTypeId: [],
				authStatus: [],
                provinceId: [],
                cityId: [],
                oneTradeId: [],
                twoTradeId: []
			},
			codeDetail: {},
			dialogOption: {
				width: '40%',
				title: '项目编辑',
				type: 1, // 0新增， 1编辑
				show: false
			}
		}
	},
	methods: {
        initProvince() {
            this.selectOption.provinceId = this.cityList.filter(item => item.parentId === 0);
        },
		// 获取选择项
        promiseAll() {
            Promise.all([this.getInfoTypeList(), this.getTradeType(), this.getStateList()]).then(res => {
                this.selectOption.bidTypeId = res[0].data || [];
                this.selectOption.oneTradeId = res[1].data || [];
                this.selectOption.twoTradeId = res[1].data[0].childTrade;
                this.selectOption.authStatus = res[2].data || [];
            });
        },
		handleDelete(row){
            this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.delete(row);
            })
		},
        async delete(row) {
            const id = row.id;
			const {code} = await this.textDel({id});
			if (Object.is(code, 200)) {
				this.$message.success('删除成功');
				this.handleGetAuthList();
			}
        },
		handleEdit(row, type, title) {
			this.codeDetail = row;
			this.dialogOption.type = type;
			this.dialogOption.title = title;
			this.dialogOption.show = true;
			this.$nextTick(()=> {
				this.$refs.edit.modelStatus(true);
			});
		},
		async handleGetAuthList() {
			this.$loading(true);
			const {pageQuery, searchQuery} = this.authOption;
			const {pageSize, currentPage}  = pageQuery;
			try {
				const {code, data} = await this.getAuthList({
					...searchQuery, pageSize, currentPage
				});
				this.authOption.data = data && data.dataSource || [];
				this.authOption.pageQuery.total = data && data.total;
			} catch (e) {
				throw e;
			} finally {
			    this.$loading(false);
			}
		},
		initCodePage() {
			console.log(1112);
		},
		skipPage({id}) {
			this.$router.push({
				path: `/audit/country/detail/${id}`,
				query: {
					event: 'getTextDetail'
				}
			})
		},
        change({value, type}) {
			this.authOption.pageQuery.currentPage = 1;
			if (type && Object.is(type, 'provinceId')) {
				this.authOption.searchQuery.cityId = '';
				this.selectOption.cityId = this.setCity(value);
			}
            if (type && Object.is(type, 'oneTradeId')) {
				this.authOption.searchQuery.twoTradeId = '';
				this.selectOption.twoTradeId = this.setTrade(value);
			}
		},
		setCity(val) {
			return this.cityList.filter(item => item.parentId === val);
		},
        setTrade(val) {
            const list = this.selectOption.oneTradeId.filter(item => item.tradeId === val);
			return val ? list[0].childTrade : [];
		},
		...mapActions('zft',['getAuthList', 'authModify', 'getInfoTypeList',
		'getProjectTypeList', 'getStateList', 'textDel', 'getTradeType'])
	},
	computed: {
		...mapGetters('zft', ['cityList']),
		columns() {
			return columnsConfig;
		}
	},
	components: {
		codeTable, topBar, edit
	},
    watch: {
		'cityList': function() {
			this.selectOption.provinceId = this.cityList.filter(item => item.parentId === 0);
		}
	}
}
</script>
<template>
<div class="rule-list">
	<top-bar
	  :handlerCodeSearch="handleGetAuthList"
	  :searchQuery="authOption.searchQuery"
	  :selectOption="selectOption"
	  @change="change"
	></top-bar>
    <code-table
     :data="authOption.data"
     :columns="columns.countryColumns"
     :searchEvent="handleGetAuthList"
     :pageOptions="authOption.pageQuery"
    >

		<el-table-column label="项目标题" align="center" slot="title" width="150" :show-overflow-tooltip="true">
            <template slot-scope="scope">
				<span class="active" @click="skipPage(scope.row)">{{scope.row.title}}</span>
	        </template>
        </el-table-column>
        <el-table-column label="操作" align="left" width="150" slot="operate" fixed="right">
            <template slot-scope="scope">
	            <el-button type="success" :disabled="+scope.row.authStatus === 1"  @click="handleEdit(scope.row, 2, '审核')">审核</el-button>
	            <!-- <el-button type="success"  @click="handleEdit(scope.row, 1, '项目编辑')">编辑</el-button> -->
	        	<el-button type="success"  @click="handleDelete(scope.row)">删除</el-button>
	        </template>
        </el-table-column>
    </code-table>
    <edit ref="edit"
	  :dialogOption="dialogOption"
	  :codeEvent="authModify"
	  :searchEvent="handleGetAuthList"
	  :codeDetail="codeDetail"
	  :selectOption="selectOption"
	></edit>
</div>
</template>
<style scoped lang="stylus">
.rule-list
    padding 20px 20px 0
	.active
	    color #286AB1
</style>
